import { withOktaAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';
import React, { FC, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
// import { useOktaAuth } from '@okta/okta-react';

const CustomImplicitCallback: FC<any> = ({ oktaAuth, authState }) => {
  const [authInfo, setAuthInfo] = useState<any>({});

  useEffect(() => {
    oktaAuth.handleLoginRedirect().then(() => {
      setAuthInfo({
        authenticated: authState.isAuthenticated,
        error: authState.error && authState.error.message,
        errorCode: authState.error && authState.error,
      });
    });
  }, [oktaAuth]);

  let location = '/';
  if (authInfo.authenticated !== null) {
    const referrerKey = 'secureRouterReferrerPath';
    location = localStorage.getItem(referrerKey) || '/';
    localStorage.removeItem(referrerKey);
  }
  const authStateReady = !authState.isPending;

  return (
    <>
      {!authInfo.isAuthenticated && authStateReady && <Redirect to="/access-denied" />}

      {authInfo.isAuthenticated ? <Redirect to={location} /> : <p>{authInfo.error}</p>}
      {/* {!authInfo.isAuthenticated && <Redirect to="/access-denied" />} */}
    </>
  );
};

CustomImplicitCallback.propTypes = {
  authState: PropTypes.oneOfType([PropTypes.object]).isRequired,
  oktaAuth: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withOktaAuth(CustomImplicitCallback);
